import { types } from '../actions/MediaResourcesActions';

function getDefaultSource() {
    return {};
}

function getResource(state, identifier) {
    return { ...(state[identifier] || getDefaultSource()) };
}

function setCachedSource(state, identifier, url) {
    const resource = getResource(state, identifier);
    resource.cachedSource = { url };
    return { ...state, [identifier]: resource };
}

function setErroredSource(state, identifier, url, crossOrigin) {
    const resource = getResource(state, identifier);
    if (resource.erroredSources?.find(source => source.url === url && source.crossOrigin === crossOrigin)) {
        return state;
    }
    resource.erroredSources = resource.erroredSources ? resource.erroredSources.slice(0) : [];
    resource.erroredSources.push({ url, crossOrigin });
    return { ...state, [identifier]: resource };
}

function setLoadedSource(state, identifier, url, crossOrigin) {
    const resource = getResource(state, identifier);
    resource.loadedSource = { url, crossOrigin };
    return { ...state, [identifier]: resource };
}

export default function (state = {}, action) {
    switch (action.type) {
    case types.MEDIA_RESOURCES_SET_CACHED_SOURCE:
        return setCachedSource(state, action.identifier, action.url);
    case types.MEDIA_RESOURCES_SET_ERRORED_SOURCE:
        return setErroredSource(state, action.identifier, action.url, action.crossOrigin);
    case types.MEDIA_RESOURCES_SET_LOADED_SOURCE:
        return setLoadedSource(state, action.identifier, action.url, action.crossOrigin);
    default:
        return state;
    }
}
